/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportSocialNetworkPostRequest { 
    companyUuid: string;
    userUuid: string;
    username?: string;
    link?: string;
    socialNetwork?: ReportSocialNetworkPostRequest.SocialNetworkEnum;
}
export namespace ReportSocialNetworkPostRequest {
    export type SocialNetworkEnum = 'FACEBOOK' | 'INSTAGRAM';
    export const SocialNetworkEnum = {
        Facebook: 'FACEBOOK' as SocialNetworkEnum,
        Instagram: 'INSTAGRAM' as SocialNetworkEnum
    };
}


